/**
 * The maximum possible RGB value
 * @type {number}
 */
export const RGB_MAX_VALUE: number = 255;
